module.exports = __webpack_public_path__ + "static/media/02_negro.a464935a.svg";